import React, { useState } from 'react';
import SftGlobalData from '../../library/SftGlobalData';
import axios from 'axios';
import { HexColorPicker } from "react-colorful";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';

const InputSetting = (props) => {
    const [value, setValue] = useState(props.defaultValue);

  const submitHandler = async (value) => {
    let postData = {
        key: props.api,
        category: props.category,
        setting: props.setting,
        value: value
    };
    if (props.groupId !== '0000') {
        postData.groupId = props.groupId;
    }

    SftGlobalData.post('mobileSettings&action=editSettings', postData).then(response => {

    });
}

  const change = (event) => {
        if(props.setting === "settSalesDefaultValue"){
            let valToSend = event.target.value;
            if(valToSend > 100){
                valToSend = "100";
            } else if(valToSend < 0 || valToSend === ""){
                valToSend = "0";
            }
            setValue(valToSend);
            submitHandler(valToSend.replace("#", ""));
        } else if(props.setting === "settSalesDefaultSalesLength"){
            let valToSend = event.target.value;
            if(valToSend > 100000){
                valToSend = "100000";
            } else if(valToSend < 0 || valToSend === ""){
                valToSend = "0";
            }
            setValue(valToSend);
            submitHandler(valToSend.replace("#", ""));
        } else {
            setValue(event.target.value);
            submitHandler(event.target.value.replace("#", ""));
        }

  }

  const changepickr = (event) => {
    setValue(event);
    submitHandler(event.replace("#", ""));
  }

  const isSales = props.category === "sales";
  const isColorField = props.setting === "elementsColor" || props.setting === "elementsTextColor";

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, py: 1.5, flexWrap: 'wrap' }}>
                <Box sx={{ minWidth: 0, flex: '1 1 240px' }}>
                    <Typography sx={{ fontWeight: 600 }}>{props.title}</Typography>
                    {props.description && props.description !== "-" &&
                        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.25 }}>{props.description}</Typography>}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1.5, flexShrink: 0 }}>
                    {isSales
                        ? <TextField
                            size="small"
                            type="number"
                            inputProps={{ min: 0, max: props.setting === "settSalesDefaultValue" ? 100 : 100000 }}
                            onChange={change}
                            value={value}
                            sx={{ width: 200 }}
                          />
                        : <TextField
                            size="small"
                            type="text"
                            onChange={change}
                            value={isColorField ? value.toUpperCase() : value}
                            sx={{ width: 200 }}
                          />}
                    {props.colorpick ? <HexColorPicker style={{ width: 200, height: 200 }} color={value} onChange={changepickr} /> : ''}
                </Box>
            </Box>
            <Divider />
        </Box>
    );
}

export default InputSetting;
